import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import http from '@/http'

const state: AliState = {
  expiration: '',
  stsPayload: {
    callbackBody: '',
    callbackUrl: '',
    endpoint: '',
    region: '',
    bucket: '',
    accessKeyId: '',
    accessKeySecret: '',
    stsToken: ''
  }
}

const getters: GetterTree<AliState, RootState> = {

}

const actions: ActionTree<AliState, RootState> = {
  getAliToken({ commit }) {
    return http.v1.ali.getAliToken().then(response => {
      commit('SET_ALI_TOKEN_DATA', response.data.data)
    })
  },
}

const mutations: MutationTree<AliState> = {
  SET_ALI_TOKEN_DATA(state, payload) {
    const { callbackBody, callbackUrl, endpoint, region, bucket, expiration, accessKeyId, accessKeySecret, token } = payload
    state.expiration = expiration
    state.stsPayload = {
      callbackBody: callbackBody,
      callbackUrl: callbackUrl,
      endpoint: endpoint,
      region: region,
      bucket: bucket,
      accessKeyId: accessKeyId,
      accessKeySecret: accessKeySecret,
      stsToken: token
    }
  }
}

const ali: Module<AliState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

export default ali